import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
declare var require: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ClientApp';

  private config: { version: string };

  constructor(private httpClient: HttpClient) {
  }

  ngOnInit() {
    this.config = require("./../assets/config.json");
    console.log("前端: " + this.config.version);

    const headers = new HttpHeaders()
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');

    this.httpClient
      .get<{ version: string }>("/version.json", { headers })
      .subscribe(config => {
        console.log("對應: " + config.version);
        if (config.version && this.config.version && config.version !== this.config.version) {
          //alert("不一樣");
          if (confirm("網頁有變更，請按下確認進行更新??")) {
            this.httpClient
              .get("", { headers, responseType: "text" })
              .subscribe(() =>
                location.reload()
              );
          }
          else {
             //alert("不更新");
          }
        }
        else {
          //alert("一樣");
        }
      });
  }
}
